import React from "react";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

// You should add these CSS rules to your project's stylesheet (e.g., index.css)
/*
.video-responsive-wrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; 
}

.video-responsive-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  border: none;
}
*/

const HowEmailAndMobileVerificationCanCutCustomerOnboardingCosts = () => {
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };

  const title =
    "How Email & Mobile Verification Can Cut Customer /nOnboarding Costs";

  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>
          How Email & Mobile Verification Can Cut Customer Onboarding Costs |
          MSB
        </title>
        <meta name="description" content="" />
        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="How Email & Mobile Verification Can Cut Customer Onboarding Costs | MSB"
        />
        <meta property="og:description" content="" />
        <meta property="og:type" content="website" />
        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
        ================================================== */}
        <section
          id="overview"
          className="page_header text-center section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <h1 className="page_title text-white">
              How Email & Mobile Verification Can Cut Customer Onboarding
              Costs
            </h1>

            {/* <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n")
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1> */}
            <ul className="breadcrumb_nav unordered_list justify-content-center d-none">
              <li>
                <NavLink to="/webinars">Webinars</NavLink>
              </li>
              <li className="active">
                <a href="#!">
                  How Email & Mobile Verification Can Cut Customer Onboarding
                  Costs
                </a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
        ================================================== */}
        {/* Contact Section - Start
        ================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              <div className="d-flex justify-content-end mb-3">
                <NavLink to="/webinars" className="btn bg-primary text-dark">
                  ← Back
                </NavLink>
              </div>
              <img
                className="rounded-2 mb-5"
                src="assets/images/webinars/how-email-and-mobile-verification-can-cut-customer-onboarding-costs.png"
                alt="How Email & Mobile Verification Can Cut Customer Onboarding Costs"
              />
              <h4>Where Real Questions Got Real Answers</h4>
              <p className="mb-5">
                In April 2025, we opened the floor—not for a presentation, but
                for a <strong>conversation</strong>. This webinar brought
                together <strong>60+ professionals</strong> from across the UK’s
                money service business sector for a live, unscripted exchange of
                insights and solutions. Our first webinar, led by{" "}
                <strong>Shane Bruce</strong> (Regional Product Manager, GBG),
                explored how email and mobile verification can streamline
                customer onboarding, reduce operational costs, and enhance
                compliance.
              </p>

              <div className="item_details_content p-3">
                <div className="row mb-5">
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/date.svg"
                        alt="Date"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Date</h5>
                        <span>Thursday, 10 April 2025</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/time.svg"
                        alt="Time"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Time</h5>
                        <span>12:00 PM GMT</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/platform.svg"
                        alt="Platform"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Platform</h5>
                        <span>Google Meet</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/attendance.svg"
                        alt="Attendance"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Attendance</h5>
                        <span>60+ MSB Professionals</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-center">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      What Made It Stand Out
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>It was interactive</li>
                          <li>It was practical</li>
                          <li>It was community-led</li>
                        </ul>
                      </div>
                    </div>
                    <div className="schedule-date fw-bold fs-5">
                      Meetup Impact at a Glance
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>
                            <strong>60+</strong> attendees from across the money
                            service business
                          </li>
                          <li>
                            <strong>90 minutes</strong> of live, unscripted
                            discussion
                          </li>
                          <li>
                            <strong>22+</strong> live questions answered
                          </li>
                          <li>
                            <strong>14 tools</strong> & <strong>tactics</strong>{" "}
                            shared during Q&A
                          </li>
                          <li>
                            Participants from <strong>10+ cities</strong> &{" "}
                            <strong>regions</strong>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <hr className="d-block d-sm-none" />

                  <div className="col-lg-6 col-md-6 col-12">
                    {/* ===== RESPONSIVE IFRAME START ===== */}
                    <div className="video-responsive-wrapper">
                      <iframe
                        src="https://www.youtube.com/embed/isiLkJtn20w"
                        title="How to Save £3,000 on Customer Onboarding | Email & Mobile Verification for MSBs | Shane Bruce"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </div>
                    {/* ===== RESPONSIVE IFRAME END ===== */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HowEmailAndMobileVerificationCanCutCustomerOnboardingCosts;
